import { render, staticRenderFns } from "./addcommercial_pzxx_edit.vue?vue&type=template&id=5f080e32&scoped=true&"
import script from "./addcommercial_pzxx_edit.vue?vue&type=script&lang=js&"
export * from "./addcommercial_pzxx_edit.vue?vue&type=script&lang=js&"
import style0 from "./addcommercial_pzxx_edit.vue?vue&type=style&index=0&id=5f080e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f080e32",
  null
  
)

export default component.exports